angular.module('app')

	.controller('HomeController', ['$scope', '$timeout', function HomeController ($scope, $timeout)
	{
		var home = this;
		var homePage = document.getElementById('home_page');
	}]);
